import { Container, Paper, Grid, Avatar, Button, Fade, Collapse, useMediaQuery } from '@mui/material';
import Box from '@mui/material/Box';
import { selectComponentStore } from '../../system/PageStore';
import { useSelector, useDispatch } from 'react-redux';
import { logoAppear } from '../../system/Slicer/HomePageSlicer';
import useWindowDimensions from '../../system/Features/WindowDimensions';
import { useNavigate } from 'react-router-dom';
import { MOURNING_MODE } from '../mourningMode';
import { MOURNING_OPEN_EVENT } from '../containers/ObituaryPop';

export function TopBanner() {
    //  const { windowWidth, windowHeight } = useWindowDimensions();
    const isPc = useMediaQuery('(min-width:600px)');
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const componentStates = useSelector(selectComponentStore);

    const logoTimeout = setTimeout(() => {
        if(!componentStates.HomePageComponentReducer.isLogoFadedIn) dispatch(logoAppear());
        clearTimeout(logoTimeout);
    }, 500);


    return <Box sx={{ mb: -1 }}>
        <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justifyContent="center"
        >
            <Button sx={{ position: "absolute", top: isPc? "9vw" : "7vw", borderRadius: "10px", p: 1 }} onClick={() => navigate("/home")}>
                <Collapse in={componentStates.HomePageComponentReducer.isLogoFadedIn} timeout={1000}>
                    <Fade in={componentStates.HomePageComponentReducer.isLogoFadedIn} timeout={1000}>
                        <Box
                            component="img"
                            sx={{ width: isPc? '10vw' : '13vw'}}
                            alt="PKPS LOGO"
                            src="http://www.pkps.edu.hk/img/website/PKPS_logo.png"
                        />
                    </Fade>
                </Collapse>
            </Button>
        </Grid>
        <Box
            component="img"
            sx={{ width: 1, minHeight: "150px", objectFit:"cover", display: "block" }}
            alt="BannerBG"
            src="http://www.pkps.edu.hk/img/website/homepageTop.jpg"
        />
        {MOURNING_MODE &&
            <Box sx={{ position: "relative", mt: -6, mb: 1, display: "flex", justifyContent: "center", zIndex: 2 }}>
                <Button
                    variant="contained"
                    onClick={() => window.dispatchEvent(new Event(MOURNING_OPEN_EVENT))}
                    sx={{
                        backgroundColor: "#1a1a1a",
                        color: "#ffffff",
                        border: "1px solid #ffffff",
                        borderRadius: "2px",
                        px: 3,
                        py: 0.75,
                        letterSpacing: "0.35em",
                        fontFamily: "'Noto Serif TC', 'Songti TC', serif",
                        fontSize: "1rem",
                        boxShadow: "0 2px 10px rgba(0,0,0,0.4)",
                        "&:hover": { backgroundColor: "#000000" },
                    }}
                >
                    訃告
                </Button>
            </Box>
        }
    </Box>
}